<div
  class="max-w-[550px] transform overflow-hidden rounded-lg bg-white p-4 font-inter shadow-xl transition-all"
  @enterLeave
>
  <div class="flex justify-between">
    <div class="mb-6 mr-8 flex items-center space-x-2 text-2xl font-bold text-aux-black">
      <aux-icon name="AlertTriangle" class="text-aux-red-dark" />
      <span>
        {{ header }}
      </span>
    </div>

    <button
      id="closeButton"
      type="button"
      class="flex rounded-md bg-white text-gray-400 hover:text-gray-700 focus:outline-none"
      (click)="closeModal()"
    >
      <span class="sr-only">Close</span>
      <aux-icon name="X" />
    </button>
  </div>

  <p class="mb-6">
    Modifying the effective date of the site budget might influence the linked budget version tied
    to a transaction, potentially impacting costs for any completed transactions. By selecting
    "Apply New Effective Date", you acknowledge and agree to this update.
  </p>

  <div class="flex justify-between">
    <aux-button label="Cancel" variant="tertiary" (click)="ref.close({ success: false })" />
    <aux-button
      label="Apply New Effective Date"
      variant="success"
      (click)="ref.close({ success: true })"
    />
  </div>
</div>
